import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

export const compactBlockStyle = css`
  padding: 48px 0;

  ${breakpoints.down('sm')} {
    padding: 32px 0;
  }
`;

export const sharedMarkdownStyles = css`
  * {
    font-family: var(--cds-font-family-source-sans-pro) !important;
    color: inherit !important;
  }

  p {
    font-size: inherit !important;
    line-height: inherit !important;
    min-height: 1rem !important;
    margin-bottom: var(--cds-spacing-200);

    & + & {
      margin-top: var(--cds-spacing-400);
    }
  }

  h1 {
    /* stylelint-disable-next-line cds-stylelint/cds-design-tokens */
    font: var(--cds-typography-display1) !important;
  }

  h2 {
    /* stylelint-disable-next-line cds-stylelint/cds-design-tokens */
    font: var(--cds-typography-display2) !important;
  }

  h3 {
    font: var(--cds-typography-title3) !important;
    font-size: 28px !important;
    font-weight: 600 !important;
  }

  h4 {
    font: var(--cds-typography-title4) !important;
    font-size: 24px !important;
    font-weight: 600 !important;
  }

  h5 {
    font: var(--cds-typography-title4) !important;
    font-size: 22px !important;
    font-weight: 600 !important;
  }

  h6 {
    font: var(--cds-typography-title4) !important;
    font-size: 20px !important;
    font-weight: 600 !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: normal !important;
    letter-spacing: -0.03em !important;
  }

  ul {
    padding-left: 0;

    li {
      list-style-type: none;
      display: flex;
      margin-top: var(--cds-spacing-200);

      svg {
        min-width: 32px;
        margin-right: var(--cds-spacing-100);
        margin-top: var(--cds-spacing-50);
      }
    }
  }

  a {
    color: var(--cds-color-interactive-primary) !important;

    &:hover {
      text-decoration: underline;
    }
  }
`;
